// =======================
// == Animations/SearchProgress.js ==
// =======================
/*
  All of the animations for SearchProgress.js
*/

import Animator from './animator';

const animator = new Animator();

const animate = () => {
  animator
    .call('#percentage', {
      opacity: [
        animator.partials.emptyStart,
        { delay: 0, value: 1, duration: 400 },
      ],
      easing: 'easeInExpo',
    })
    .call('#progressBar', animator.animations.downAndFadeOut)
    .call('#copy', {
      opacity: [
        animator.partials.emptyStart,
        { delay: 300, value: 1, duration: 800 },
      ],
      easing: 'easeInOutQuad',
    });
};

export default animate;
